function Home() {
  return (
    <>
      <header className="header"></header>
      <h1></h1>
      <section className="about"></section>
    </>
  )
}

export default Home
